import {
  Box,
  Button,
  Typography,
  TextField,
  Paper,
  Alert,
} from "@mui/material";
import { NationBuilderAccessTokenStatus } from "../../common/models/schema/NationBuilderAccessTokenStatus";
import { useNationBuilderToken } from "../../common/contexts/NationBuilderTokenProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/RUFLogo.png";

const image_placeholder = (
  <Box
    sx={{
      width: 120,
      height: 120,
      bgcolor: "#fff",
      borderRadius: 3,
      mb: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#888",
      fontWeight: 700,
      fontSize: 18,
      boxShadow: 2,
    }}
  >
    <img
      src={logo}
      alt="Romanian United Foundation Logo"
      style={{ width: "100%", height: "100%", borderRadius: "50%" }}
    />
  </Box>
);

const NationBuilderSignInPage = () => {
  const navigate = useNavigate();
  const {
    handleNationBuilderSignIn: handleNationBuilderSignIn,
    tokenState,
    isLoading,
  } = useNationBuilderToken();

  useEffect(() => {
    if (tokenState === NationBuilderAccessTokenStatus.Valid) {
      navigate("/dashboard", { replace: true });
    }
  }, [tokenState]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F5F5F5",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        elevation={8}
        sx={{
          p: 0,
          borderRadius: 4,
          minWidth: 700,
          minHeight: "50vh",
          maxWidth: "95vw",
          bgcolor: "#232324",
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
        }}
      >
        {/* Left column */}
        <Box
          sx={{
            width: 300,
            bgcolor: "#fff",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 4,
          }}
        >
          {image_placeholder}
          <Typography
            variant="h6"
            sx={{
              color: "#02ACF0",
              fontWeight: 900,
              textAlign: "center",
              letterSpacing: 1.5,
              fontSize: 20,
              mt: 1,
            }}
          >
            ROMANIAN UNITED FOUNDATION
          </Typography>
        </Box>
        {/* Right column */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 6,
            bgcolor: "#02ACF0",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: "#fff",
              textAlign: "center",
              letterSpacing: 1,
            }}
          >
            Sign in to the NationBuilder API
          </Typography>

          <Button
            variant="contained"
            onClick={handleNationBuilderSignIn}
            disabled={isLoading}
            sx={{
              mt: 1,
              minWidth: 180,
              minHeight: 50,
              fontWeight: 700,
              fontSize: "1.3rem",
              borderRadius: 2,
              bgcolor: "#fff", //02ACF0
              color: "#226298",
              boxShadow: "0 4px 20px 0 #00055",
              "&:hover": {
                // bgcolor: "#5D9CC3",
                transform: "scale(1.05)",
                transition: "transform 0.2s",
              },
              "&:disabled": {
                bgcolor: "#fff",
                color: "orange",
                cursor: "not-allowed",
              },
            }}
          >
            {isLoading ? "Loading..." : "Sign in"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NationBuilderSignInPage;
